// extracted by mini-css-extract-plugin
module.exports = {"selectedTags":"base-module__selectedTags___23BP_","selectedTag":"base-module__selectedTag___2JNvb"};